import { IUpdateItemChecklistServicoUseCase } from "../../../presentation/useCases/update/update_item_checklist_servico_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateItemChecklistServicoUseCase
 */

export class UpdateItemChecklistServicoUseCase implements IUpdateItemChecklistServicoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateItemChecklistServico(
    idItemChecklistServico: number,
    ordem: string,
    descricao: string,
    resumoItem: string | null,
    metodoVerificacao: string | null,
    tolerancia: string | null,
  ): Promise<void> {
    await this.repository.updateItemChecklistServico(
      idItemChecklistServico,
      ordem,
      descricao,
      resumoItem ?? '',
      metodoVerificacao,
      tolerancia,
    );
  }
}
